import { render, staticRenderFns } from "./DispatchDetailsView.vue?vue&type=template&id=5f3a70d5"
import script from "./DispatchDetailsView.vue?vue&type=script&lang=js"
export * from "./DispatchDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports